import React from 'react';
import { Box, Typography } from '@mui/material';
import {
  NoteAutosaveStatus,
  noteAutosaveStatusPresentation,
} from '../utils/noteAutosaveStatus';

interface NoteStatusIndicatorProps {
  status: NoteAutosaveStatus;
}

/** Maps the presentation color token to a concrete dot color. */
const DOT_COLOR: Record<
  ReturnType<typeof noteAutosaveStatusPresentation>['color'],
  string
> = {
  success: '#2e7d32', // green
  info: '#0288d1', // blue
  warning: '#ed6c02', // yellow/amber
  error: '#d32f2f', // red
  disabled: '#9e9e9e', // grey
};

/**
 * Small colored dot + label reflecting the note's autosave status.
 *   green Saved · blue Saving · yellow Draft/Offline-draft · grey Offline · red Error
 */
const NoteStatusIndicator: React.FC<NoteStatusIndicatorProps> = ({
  status,
}) => {
  const { color, label } = noteAutosaveStatusPresentation(status);
  return (
    <Box
      sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}
      aria-live="polite"
    >
      <Box
        sx={{
          width: 10,
          height: 10,
          borderRadius: '50%',
          bgcolor: DOT_COLOR[color],
          flexShrink: 0,
        }}
      />
      <Typography variant="caption" color="text.secondary">
        {label}
      </Typography>
    </Box>
  );
};

export default NoteStatusIndicator;
